import React, { ReactNode } from 'react';

type CarouselGalleryProps = {
  children: ReactNode;
};
export function CarouselGallery({ children }: CarouselGalleryProps) {
  return (
    <div className="image-gallery__slider">
      <div className="image-gallery__carousel">
        {/* Since children always exist, the table is never empty */}
        <ol className="image-gallery__carousel-viewport">{children}</ol>
      </div>
    </div>
  );
}
